import type { DomainsConfig, AllowedDomain } from './hooks/config'
import { SITE_ENV } from './common'

const DOMAIN_CONFIG_DEV: DomainsConfig = {
  'fedefarma.dev': {
    GATEWAY_BASE_URL: 'https://gateway-dev.farmacloud.io',
    OAUTH_BASE_URL: 'https://accountsbackend-dev.farmacloud.io',
    ROOT_SITE: 'https://cloud.fedefarma.dev'
  },
  'farmacloud.io': {
    GATEWAY_BASE_URL: 'https://gateway-dev.farmacloud.io',
    OAUTH_BASE_URL: 'https://accountsbackend-dev.farmacloud.io',
    ROOT_SITE: 'https://dev.farmacloud.io'
  },
  'appcloud.io': {
    GATEWAY_BASE_URL: 'https://gateway-dev.appcloud.io',
    OAUTH_BASE_URL: 'https://accountsbackend-dev.appcloud.io',
    ROOT_SITE: 'https://dev.appcloud.io'
  }
}
  
const DOMAIN_CONFIG_STG: DomainsConfig = {
  'farmacloud.io': {
    GATEWAY_BASE_URL: 'https://gateway-stg.farmacloud.io',
    OAUTH_BASE_URL: 'https://accountsbackend-stg.farmacloud.io',
    ROOT_SITE: 'https://stg.farmacloud.io'
  },
  'appcloud.io': {
    GATEWAY_BASE_URL: 'https://gateway-stg.appcloud.io',
    OAUTH_BASE_URL: 'https://accountsbackend-stg.appcloud.io',
    ROOT_SITE: 'https://stg.appcloud.io'
  }
}

const DOMAIN_CONFIG_PRO: DomainsConfig = {
  'farmacloud.io': {
    GATEWAY_BASE_URL: 'https://gateway.farmacloud.io',
    OAUTH_BASE_URL: 'https://accountsbackend.farmacloud.io',
    ROOT_SITE: 'https://app.farmacloud.io'
  },
  'appcloud.io': {
    GATEWAY_BASE_URL: 'https://gateway.appcloud.io',
    OAUTH_BASE_URL: 'https://accountsbackend.appcloud.io',
    ROOT_SITE: 'https://app.appcloud.io'
  }
}

let DOMAIN_CONFIG: DomainsConfig
if (SITE_ENV === 'dev') {
  DOMAIN_CONFIG = DOMAIN_CONFIG_DEV
} else if (SITE_ENV === 'stg') {
  DOMAIN_CONFIG = DOMAIN_CONFIG_STG
} else {
  DOMAIN_CONFIG = DOMAIN_CONFIG_PRO
}

let CURRENT_DOMAIN = window.location.hostname.split('.').splice(-2).join('.') as AllowedDomain
if (!DOMAIN_CONFIG[CURRENT_DOMAIN]) {
  CURRENT_DOMAIN = 'farmacloud.io'
}

export {
  CURRENT_DOMAIN,
  DOMAIN_CONFIG
}
  